module.exports = "<p>\n  tooltips works!\n</p>\n"